import { Card } from 'cdhs-ui-library';
import styles from './about.module.scss';
import IMAGE from '../../config/imgConfig';
import ContactUs from '../../components/ContactUs/ContactUs'; // Assuming this is semantically sound
import { useTranslations } from '../../contexts/LanguageContext';

function About() {
  const t = useTranslations();

  const card1Content = (
    <>
      {/* Changed from h1 to h2 for proper hierarchy */}
      <h2 id="about-survey-heading">{t('aboutPage_card1Title', 'About the survey')}</h2>
      <p>{t('aboutPage_card1Paragraph1', 'This survey helps us understand your experiences and needs as you transition to adulthood. ')}</p>
      <p>{t('aboutPage_card1Paragraph2', "We'll ask about things like your education, employment, support network, future plans, and any assistance you receive, such as education vouchers or health insurance.")}</p>
    </>
  );

  const card2Content = (
    <>
      {/* Changed from h1 to h2 for proper hierarchy */}
      <h2 id="survey-topics-heading">{t('aboutPage_card2Title', 'Survey question topics')}</h2>
      <p>{t('aboutPage_card2Intro', 'The survey questions will ask about topics such as:')}</p>
      <ul>
        <li>{t('aboutPage_card2ListItem1', 'financial self-sufficiency')}</li>
        <li>{t('aboutPage_card2ListItem2', 'experience with homelessness')}</li>
        <li>{t('aboutPage_card2ListItem3', 'educational attainment')}</li>
        <li>{t('aboutPage_card2ListItem4', 'positive connections with adults')}</li>
        <li>{t('aboutPage_card2ListItem5', 'high-risk behavior')}</li>
        <li>{t('aboutPage_card2ListItem6', 'access to health insurance')}</li>
      </ul>
    </>
  );

  return (
    <div>
      <section className={styles.hero} aria-labelledby="about-nytd-main-heading">
        <img 
          src={IMAGE.ABOUT_HERO.url} 
          alt={t('alt_aboutHero', IMAGE.ABOUT_HERO.alt)}
          className={styles.heroImg} 
        />
        <div className={styles.heroText}>
          <h1 id="about-nytd-main-heading" className={styles.heroTitle}>{t('aboutPage_heroTitle', 'About NYTD')}</h1>
          <p>{t('aboutPage_heroParagraph1', 'The NYTD (National Youth in Transition Database) project is a federal effort in all 50 states to improve support for youth transitioning from foster care to adulthood. ')}</p>
          <p>{t('aboutPage_heroParagraph2', "The  Youth Experiences Survey is the state of Colorado’s version of the NYTD survey.")}</p>
          <p>{t('aboutPage_heroParagraph3', 'The project follows young people from 17 to 21 to understand their needs and evaluates how we can make the transition to independence smoother. ')}</p>
          <p>{t('aboutPage_heroParagraph4', 'By sharing their experiences, youth participants are helping shape a better foster care system.')}</p>
        </div>
      </section>

      <section className={styles.body} aria-label={t('aboutPage_bodySectionLabel', "Survey Details")}>
        <div className={styles.bodyContent}>
          <Card>{card1Content}</Card>
        </div>
        <div className={styles.bodyCard}>
          <Card>{card2Content}</Card>
        </div>
      </section>

      <ContactUs /> 
    </div>
  );
}

export default About;
